/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPowerOn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.667 4.547A10.017 10.017 0 0 1 22 12c0 5.514-4.487 10-10 10-5.514 0-10-4.486-10-10a9.99 9.99 0 0 1 3.332-7.453l1.335 1.49a7.991 7.991 0 0 0-1.836 2.408A7.913 7.913 0 0 0 4 12c0 4.41 3.588 8 8 8 4.411 0 8-3.59 8-8a8.015 8.015 0 0 0-2.667-5.963zM13.005 2v11h-2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPowerOn as PowerOn };
